import { Directive } from "@angular/core";

import { HostListener, inject } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

@Directive({
  selector: '[matTooltip]',
  standalone: false,
})
export class MatTooltipClickableDirective {

  private matTooltip = inject(MatTooltip);

  @HostListener('click')
  onClick() {
    this.matTooltip.toggle();
  }

}